import React from 'react';
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {TaskSingleVoyageTransformForTable} from "@containers/singleVoyage/tasks/table/types";
import {getValueTransformData} from "@helpers/transform/transform";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface IProps {
    column: IColumnItem<TaskSingleVoyageTransformForTable>,
    content: TaskSingleVoyageTransformForTable
}

const CurrentValueItemTableTaskSingleVoyage = ({
                          content,
                          column
                      }: IProps) => {

    if (column.id === 'waypoints') {
        return (
            <Stack
                gap={1}
            >
                {content.waypoints?.map((point) => {
                    return (
                        <Typography
                            key={point.id}
                        >
                            {point.plannedOrdinal + 1}. {point.name}
                        </Typography>
                    )
                })}
            </Stack>
        )
    }
    return (
        getValueTransformData(content, column.id)
    );
};

export default CurrentValueItemTableTaskSingleVoyage;
